<template>
  <template v-if="userCalendarStore.currentUserCalendar.isGoogleAuthenticated">
    <div class="layout font">
      <CheckmarkIcon />
      <span class="ml-2">Google Calendar Connected</span>
    </div>
  </template>
  <template v-else>
    <button class="layout font clickable" @click="e => connectGoogle(e)">
      <GoogleCalendarIcon />
      Connect Google Calendar
    </button>
  </template>
</template>

<script setup lang="ts">
import { useCurrentUserStore } from '@/stores/currentUser';
import GoogleCalendarIcon from './GoogleCalendarIcon.vue';
import { useUserCalendarStore } from '@/stores/userCalendar';
import CheckmarkIcon from './CheckmarkIcon.vue';

const currentUserStore = useCurrentUserStore();
const userCalendarStore = useUserCalendarStore();

const connectGoogle = async (e: MouseEvent) => {
  e.preventDefault();

  const form = makeForm();
  const csrfInput = makeCSRFInput();
  form.appendChild(csrfInput);

  document.body.appendChild(form);
  form.submit();
  form.remove();
};

const makeForm = () => {
  const loginHint = encodeURIComponent(currentUserStore.currentUserAccountDetails.username);

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `/users/auth/google?prompt=consent&login_hint=${loginHint}`;
  return form;
};

const makeCSRFInput = () => {
  const csrf = (document.querySelector('[name="csrf-token"]') as HTMLMetaElement).content;
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'authenticity_token';
  input.value = csrf;
  return input;
};
</script>

<style scoped>
@reference "tailwindcss";
.layout {
  @apply flex w-full justify-center items-center border border-gray-200 rounded-full py-4;
}

.font {
  @apply text-sm leading-5 text-gray-700 font-medium;
}

.clickable {
  @apply cursor-pointer hover:text-gray-500 focus:outline-none  focus:border-indigo-300 transition ease-in-out duration-150;
}
</style>
